export default __webpack_public_path__ + "static/media/c3.d0d70cf4.jpg";